export default "__VITE_ASSET__BULtpqd0__"